<template lang="html">
  <div class="add">
    <ArtworkForm />
  </div>

</template>

<script>
import ArtworkForm from '../components/ArtworkForm.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'add',
  mounted() {
    this.$store.dispatch('resetState')
  },
  components: {
    ArtworkForm
  }
}
</script>

<style lang="css" scoped>
</style>
